import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const AdminRoot = lazy(() =>
  import(
    /* webpackPrefetch: true */
    /* webpackChunkName: 'admin-root' */
    './AdminApp'
  )
)

export function AsyncAdminRoot(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Admin Panel..." />}>
      <AdminRoot {...props} />
    </Suspense>
  )
}

export { ADMIN_PATHNAME } from './components/AdminRoot'
export default AsyncAdminRoot
